import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { routeToPage } from 'support/helpers/navigation/navigation';
import { MessageV2DTO, TransactionsRoutes } from 'support/types';
import { Alert } from 'components/Display/Alert/Alert';

import { isDocumentClone } from './helpers';

type CloneDocumentBannerProps = {
  message: MessageV2DTO | undefined;
};

export function ClonedDocumentBanner({ message }: CloneDocumentBannerProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const alertConfig = useMemo(() => {
    if (isDocumentClone(message)) {
      const isDocumentCloneMessageAvailable = !!message.cloned_message;
      return {
        text: t('transactions:show.sections.alert.clone.text'),
        buttonLabel: isDocumentCloneMessageAvailable
          ? t('transactions:show.sections.alert.clone.buttonLabel.clonedDocumentAvailable')
          : t('transactions:show.sections.alert.clone.buttonLabel.clonedDocumentNotAvailable'),
        analyticsId: 'clone-alert-view-original',
        routeUrl: routeToPage(TransactionsRoutes.viewMessage, { id: message.cloned_message_id }),
        disabled: !isDocumentCloneMessageAvailable,
      };
    }
  }, [message, t]);

  if (!alertConfig) {
    return null;
  }

  return (
    <Alert
      severity="neutral"
      withoutIcon
      fullWidth
      actions={{
        primary: {
          onClick: () => navigate(alertConfig.routeUrl),
          children: alertConfig.buttonLabel,
          analyticsId: alertConfig.analyticsId,
          disabled: alertConfig.disabled,
        },
      }}
    >
      {alertConfig.text}
    </Alert>
  );
}
